module.exports = __webpack_public_path__ + "assets/img/back-c4f83498.png";